import initialState from './initialState';

import {
  RECEIVE_LATEST_CONTRACTS,
  HANDLE_LATEST_CONTRACTS_ERROR
} from '../actions/actionTypes';

export function latestContracts(state = initialState.latestContracts, action) {
  switch (action.type) {
    case RECEIVE_LATEST_CONTRACTS:
      return action.latestContracts;
    default:
      return state;
  }
}

export function latestContractsError(state = initialState.latestContractsError, action) {
  switch (action.type) {
    case HANDLE_LATEST_CONTRACTS_ERROR:
      return action.latestContractsError;
    default:
      return state;
  }
}
